module.exports = __webpack_public_path__ + "static/media/vinsmoke-reiju-lose.c3d49da8.png";